export default function bbpsApi(fetch, baseUrl) {

    return {
        
        // BBPS Category Management
        getBBPSCategories() {
            return fetch.get(`${baseUrl}/config/categories`);
        },
        
        updateBBPSCategory({ payload }) {
            return fetch.post(`${baseUrl}/config/categories`, payload);
        },

        deleteBBPSCategory({ categoryId }) {
            return fetch.delete(`${baseUrl}/config/categories/${categoryId}`);
        },

        // BBPS Complaint Management
        getBBPSComplaints({ orderId }) {
            return fetch.get(`${baseUrl}/complaints?orderId=${orderId}`);
        },
        createBBPSComplaint({ payload }) {
            return fetch.post(`${baseUrl}/complaints`, payload);
        },
        updateBBPSComplaint({ complaintId, payload }) {
            return fetch.put(`${baseUrl}/complaints/${complaintId}`, payload);
        }
    }
}